module.exports = __webpack_public_path__ + "static/media/plastic.ff98dd0c.jpeg";